import { fromConsignmentResponse, toConsignmentRequest } from '../models/mapper'
import { ConsignmentSave } from '../models/request'
import { Consignment } from '../models/types'
import { updateConsignmentDraftV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function updateConsignmentDraft(id: number, data: ConsignmentSave): Promise<Consignment> {
  const response = await updateConsignmentDraftV2(id, toConsignmentRequest(data))
  return fromConsignmentResponse(response)
}
